import React, { FC, useEffect } from 'react';
import { Form } from 'react-final-form';
import apiRoutes from '../../../../config/api/routes';
import { useFetch } from '../../../shared/hooks';
import { DifferentiationScreenAction } from './DifferentiationScreenAction';
import { ScreenProps } from './DifferentiationsContainer';
import { DifferentiationVisibilityForm } from './DifferentiationVisibilityForm';
import { IGroupVisibility, ITrajectoryDifferentiation } from '../../../../config/api/models/Trajectory';

const calculateInitialVisibilityValues = (
  groupVisibilities: IGroupVisibility[]
): Record<string, boolean> => {
  const initialValue: Record<string, boolean> = {};
  const result = groupVisibilities.reduce((obj, item) => ({...obj, [item.id]: item.isSelected}), initialValue);
  return result;
};

export const UpdateDifferentiationVisibility: FC<ScreenProps & {
  differentiations: ITrajectoryDifferentiation[];
}> = ({ openCallback, metaData, differentiations }) => {
  const [getTrajectoryVisibilitiesResponse, getTrajectoryVisibilities] = useFetch<IGroupVisibility[]>(
    apiRoutes.getTrajectoryGroupVisibilities(metaData.version?.id as string)
  );

  useEffect(getTrajectoryVisibilities, [getTrajectoryVisibilities]);

  const [putTrajectoryVisibilityResponse, putTrajectoryVisibility] = useFetch('', {
    method: 'PUT',
  });

  useEffect(() => {
    if (putTrajectoryVisibilityResponse.success) {
      openCallback(DifferentiationScreenAction.OVERVIEW, "REFETCH");
    }
  }, [putTrajectoryVisibilityResponse, openCallback]);

  return (
    <>
      {getTrajectoryVisibilitiesResponse.success && metaData.version && (
        <Form
          initialValues={calculateInitialVisibilityValues(getTrajectoryVisibilitiesResponse.data)}
          onSubmit={(values: Record<string, boolean>) => {
            putTrajectoryVisibility({
              path: apiRoutes.visibility(metaData.version ? metaData.version.id : ''),
              body: Object.keys(values).map((key: string) => ({
                groupId: key,
                isVisible: values[key],
              })),
            });
          }}
          render={({ handleSubmit }) => (
            <DifferentiationVisibilityForm
              handleSubmit={handleSubmit}
              bookGroupVisibility={getTrajectoryVisibilitiesResponse.data}
              openCallback={openCallback}
              differentiations={differentiations}
              currentDifferentiationId={metaData.version ? metaData.version.id : ''}
            />
          )}
        />
      )}
    </>
  );
};
